import { render, staticRenderFns } from "./DataToggle.vue?vue&type=template&id=826d13ea&scoped=true"
import script from "./DataToggle.vue?vue&type=script&lang=js"
export * from "./DataToggle.vue?vue&type=script&lang=js"
import style0 from "./DataToggle.vue?vue&type=style&index=0&id=826d13ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826d13ea",
  null
  
)

export default component.exports